import React, { useState } from 'react'
import './EmailConfig.css'
import { Button, Col, Input, Row, Switch, Table } from 'antd'


const userColumn = [
    {
        title: 'User Name',
        dataIndex: 'username',
        key: 'username',
        align: 'center',
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        align: 'center',
    },
    {
        title: 'Team',
        dataIndex: 'team',
        key: 'team',
        align: 'center',
    },
]

const EmailConfig = () => {

    const [switchVal, setSwitchVal] = useState(true);

    const handleSwitchChange = (checked) => {
        console.log(checked, 'checked');
        setSwitchVal(checked);
    }

    return (
        <div className='emailConfigMainClass'>
            <h2 className='subHeader'>Email Configurations</h2>
            <div className='emailConfigDiv'>
                <h3>Email Subject</h3>
                <Input placeholder="Email Subject" className='emailConfigInput' />
            </div>
            <div className='emailConfigDiv'>
                <h3>Email Body Prefix</h3>
                <Input.TextArea placeholder="Email Body Prefix" rows={4} className='emailConfigInput' />
            </div>
            <div className='emailConfigDiv'>
                <h3>Global Trigger</h3>
                <p>(<span>Note</span> : By turning this off, Mail will be sent to all users.)</p>
                <Switch onChange={handleSwitchChange} className='emailConfigSwitch' checkedChildren="ON" defaultChecked unCheckedChildren="OFF" />
                {
                    !switchVal ?
                        <Row className='Tableset' style={{ marginBottom: '25px' }}>
                            <Col span={10}>
                                <h3>Mapped Users</h3>
                                <Input.Search placeholder='Search users' className='emailConfigInput' />
                                <Table columns={userColumn} dataSource={[]} />
                            </Col>
                            <Col offset={1} span={10}>
                                <h3>Mapped Users</h3>
                                <Input.Search placeholder='Search users' className='emailConfigInput' />
                                <Table columns={userColumn} dataSource={[]} />
                            </Col>
                        </Row>
                        :
                        <></>
                }
            </div>
            <div>
                <Button type='primary' block style={{ height: '40px' }}>Save changes</Button>
            </div>
        </div>
    )
}

export default EmailConfig